import styled from '@emotion/styled';

export const LoadTitle = styled.div`
  border-radius: 6px;
  width: 250px;
  height: 30px;
  margin-bottom: 10px;
`;

export const LoadRowContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
`;

export const LoadFlex = styled.div`
  flex: 1;
  min-width: 0; /* evita overflow en layouts estrechos */
`;

export const LoadCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 8px;
  min-height: 200px;
  height: 100%;
  width: 100%;
  flex: 0 0 327px;
  border-radius: 12px;
  margin-right: 32px;
`;

export const LoadWeekProgressLinesk = styled(LoadCardContainer)`
  margin: 20px 0;
`;

export const SkeletonBox = styled.div<{
  w?: string;
  h?: string;
  r?: string;
}>`
  width: ${({ w }) => w ?? '100%'};
  height: ${({ h }) => h ?? '16px'};
  border-radius: ${({ r }) => r ?? 'var(--sk-radius)'};
  position: relative;
  overflow: hidden;
  background-color: var(--sk-bg);

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(
      90deg,
      transparent,
      var(--sk-highlight),
      transparent
    );
    animation: sk-shimmer var(--sk-duration) ease-in-out infinite;
  }
`;
